import { render, staticRenderFns } from "./StatiMultiSelect.vue?vue&type=template&id=422c32f6&"
import script from "./StatiMultiSelect.vue?vue&type=script&lang=js&"
export * from "./StatiMultiSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports